function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  stroke: "#fff",
  fill: "none",
  strokeMiterlimit: 10,
  d: "M31.21.5l-15 15-15-15h30z"
});

function SvgTotop(props) {
  return React.createElement("svg", _extends({
    className: "totop_svg__caret__img",
    viewBox: "0 0 32.41 16.21"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iY2FyZXRfX2ltZyAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZpZXdCb3g9IjAgMCAzMi40MSAxNi4yMSI+CiAgPHBvbHlnb24gdmVjdG9yLWVmZmVjdD0ibm9uLXNjYWxpbmctc3Ryb2tlIiBzdHJva2U9IiNmZmYiIGZpbGw9Im5vbmUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgcG9pbnRzPSIzMS4yMSAwLjUgMTYuMjEgMTUuNSAxLjIxIDAuNSAzMS4yMSAwLjUiPjwvcG9seWdvbj4KPC9zdmc+Cg==";
export { SvgTotop as ReactComponent };